import { NotFoundPage } from "@homesite/ui";
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";

export const notFoundRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "$",
	component: function NotFound() {
		return <NotFoundPage homeHref="/" />;
	},
});
